export const environment = {
  production: false,
  apiUrl: `https://api.aoc-performance-review-dev.riotinto-dna.com/aoc-per-rev-api/api`,
  cognito: {
    userPoolId: 'ca-central-1_hEG2ZRPsn',
    userPoolWebClientId: '412c4gq69k2b7lm2a3pghm1b4s',
    identityPoolId: 'ca-central-1:f7bf0b9c-b56e-43bb-a75e-84d284e40c5e',
    domain: 'aoc-per-rev-dev.auth.ca-central-1.amazoncognito.com',
    redirectSignIn: 'https://aoc-performance-review-dev.riotinto-dna.com/',
    redirectSignOut: 'https://aoc-performance-review-dev.riotinto-dna.com/',
    region: 'ca-central-1',
  },
};
